import React from "react";
import { heatColor } from "@/components/demand/UsStateMap";

const TH = "px-2 py-1.5 text-[9px] uppercase tracking-widest text-left whitespace-nowrap";

export const DemandGrid = ({ data, mode, selected, onSelect }) => {
  const cols = mode === "case"
    ? data.case_types.map((c) => ({ key: c.slug, label: c.label }))
    : data.funnels.map((f) => ({ key: f.slug, label: f.title }));
  const field = mode === "case" ? "by_case" : "by_funnel";
  const max = Math.max(0, ...data.states.flatMap((s) => Object.values(s[field])));
  if (!data.states.length) return null;
  return (
    <div className="overflow-x-auto border-2 border-black bg-white" data-testid="demand-grid">
      <table className="w-full text-xs min-w-[640px]">
        <thead className="bg-zinc-100">
          <tr>
            <th className={TH}>State</th>
            {cols.map((c) => <th key={c.key} className={TH}>{c.label}</th>)}
            <th className={TH}>Total</th>
          </tr>
        </thead>
        <tbody>
          {data.states.map((s) => (
            <tr key={s.state} onClick={() => onSelect(selected === s.state ? null : s.state)}
                className={`border-t border-zinc-200 cursor-pointer ${selected === s.state ? "outline outline-2 outline-black" : "hover:bg-zinc-50"}`}
                data-testid={`demand-grid-row-${s.state}`}>
              <td className="px-2 py-1.5 font-bold font-mono">{s.state}</td>
              {cols.map((c) => {
                const n = s[field][c.key] || 0;
                return (
                  <td key={c.key} className="px-2 py-1.5 font-mono text-center"
                      style={{ background: heatColor(n, max), color: n / Math.max(1, max) > 0.4 ? "#fff" : "#000" }}
                      data-testid={`demand-grid-cell-${s.state}-${c.key}`}>
                    {n || ""}
                  </td>
                );
              })}
              <td className="px-2 py-1.5 font-mono font-bold">{s.unmatched}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
